<div class="container-tab-lists nxtdc">
  <div class="inner-tcontainer-tab">
    <div style="position:relative">
      <div class="deployment-info">
        <h2 class="flex-aligned-div" (click)="openDeploymentInformationPopup()">
          Deployment information
          <mat-icon data-html="true" class="info-icon">info</mat-icon>
        </h2>
      </div>
      <div class="tab-body">
        <div class="tab-content">
          <mat-tab-group #tabGroup
            (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel);"
            mat-stretch-tabs="false">
            @if (defaults.isMFGAdminPDCSUser) {
              <mat-tab label="Controller Releases">
                <div class="centered-tabs controller-tabs">
                  <mat-tab-group  mat-stretch-tabs="false" mat-align-tabs="center">
                    <mat-tab label="Non Contract Specific">
                      <controllersoftwarerelease [availableFamilyCodes]="availableFamilyCodes"
                        [availableProductUsages]="availableProductUsages"
                        [availableLanguages]="availableLanguages"
                        [isContractSpecific]="false">
                      </controllersoftwarerelease>
                    </mat-tab>
                    <mat-tab label="Contract Specific">
                      <controllersoftwarerelease [availableFamilyCodes]="availableFamilyCodes"
                        [availableProductUsages]="availableProductUsages"
                        [availableLanguages]="availableLanguages"
                        [isContractSpecific]="true">
                      </controllersoftwarerelease>
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </mat-tab>
            }
            @if (defaults.isMFGAdminPDCSUser) {
              <mat-tab label="Peripheral Releases">
                <text-filter-bar
                  [fields]="peripheralFilterFields"
                  (filterChange)="onPeripheralFilterChange($event)">
                </text-filter-bar>
                <div class="centered-tabs controller-tabs">
                  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
                    <mat-tab label="Non Contract Specific">
                      <peripheralsoftware #periphearalSoftwareComponent
                        [availableFamilyCodes]="availableFamilyCodes"
                        [availableLanguages]="availableLanguages"
                        [boardFilter]="peripheralBoardFilter"
                        [familyCodeFilter]="peripheralFamilyCodeFilter"
                      [isContractSpecific]="false"></peripheralsoftware>
                    </mat-tab>
                    <mat-tab label="Contract Specific">
                      <peripheralsoftware #periphearalSoftwareComponent
                        [availableFamilyCodes]="availableFamilyCodes"
                        [availableLanguages]="availableLanguages"
                        [boardFilter]="peripheralBoardFilter"
                        [familyCodeFilter]="peripheralFamilyCodeFilter"
                      [isContractSpecific]="true"></peripheralsoftware>
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </mat-tab>
            }

            <mat-tab label="Family Code">
              <tdcfamilycode #tdcfamilycodeComponent [availableComponentFunctions]="availableComponentFunctions" (familyCodesEvent)="loadFamilyCodes($event)"></tdcfamilycode>
            </mat-tab>
            <mat-tab label="Function Type">
              <tdcfunctiontype #tdcfunctiontypeComponent (compFunctionsEvent)="loadCompFunctions($event)"></tdcfunctiontype>
            </mat-tab>
            @if (defaults.isMFGAdminPDCSUser) {
              <mat-tab label="Nvstruct Schemas">
                <nvstructmasterdata [originalSoftwareReleases]="originalSoftwareReleases"></nvstructmasterdata>
              </mat-tab>
            }

            @if (defaults.isMFGAdminPDCSUser) {
              <mat-tab label="Commands Files">
                <commandsmasterdata [originalSoftwareReleases]="originalSoftwareReleases"></commandsmasterdata>
              </mat-tab>
            }
            <mat-tab label="BOM Mapping">
              <tdcbomcodemapping #tdcbomcodemappingComponent [availableFamilyCodes]="availableFamilyCodes"></tdcbomcodemapping>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>
